/* eslint-disable */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { eventRequestConfirmUI, eventRequestFinish, eventRequestRefuseUI } from '@/store/course/actions';
import { getIncome } from '@/store/income/actions';
import {
  checkStudyPlan,
  clearPlan,
  deleteStudyPlan,
  finishAllPlansForTopics,
  getStudyPlan,
  getStudyPlanDinamic,
  sendNotificationStudyPlanFinished,
  updateStudyPlanStatus,
} from '@/store/study-plan/actions';
import { checkTopicComment, showSendReviewModal } from '@/store/topics/actions';
import {
  createProfileUserTopic,
  createUserTopicToMultipleUsers,
  deleteProfileUserTopic,
  sendNotification,
} from '@/store/user-topics/actions';
import { getUserById, getUsers } from '@/store/users/actions';

import { selectOpenDate } from '@/store/course/selectors';
import { selectLogin as loginSelect } from '@/store/login/selectors';
import { selectStudyPlan as studyPlanSelect } from '@/store/study-plan/selectors';
import { selectUsers as usersSelect } from '@/store/users/selectors';

import { Button } from 'antd';
import MaterialButton from '@/components/MaterialButton';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';

import { createSelector } from '@reduxjs/toolkit';
import classNames from 'classnames';
import dayjs from 'dayjs';
import _get from 'lodash/get';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';

import css from './Planning.module.scss';

export class StudyPlanButton extends Component {
  static propTypes = {
    actionType: PropTypes.string,
    activeMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    checkCoursePlan: PropTypes.bool,
    checkIsEnd: PropTypes.bool,
    checkStudyPlan: PropTypes.func,
    checkTopicComment: PropTypes.func,
    clearPlan: PropTypes.func,
    courseStatus: PropTypes.string,
    createProfileUserTopic: PropTypes.func,
    createToPlan: PropTypes.func,
    createUserTopicToMultipleUsers: PropTypes.func,
    currentUserId: PropTypes.number,
    deleteProfileUserTopic: PropTypes.func,
    deleteStudyPlan: PropTypes.func,
    externalLogin: PropTypes.bool,
    finishAllPlansForTopics: PropTypes.func,
    getIncome: PropTypes.func,
    getStudyPlan: PropTypes.func,
    getStudyPlanDinamic: PropTypes.func,
    handleCreateToPlanClick: PropTypes.func,
    isAnother: PropTypes.bool,
    isTopic: PropTypes.bool,
    mention: PropTypes.bool,
    page: PropTypes.number,
    plan: PropTypes.object,
    planId: PropTypes.number,
    planMonth: PropTypes.string,
    sendNotification: PropTypes.func,
    showCalendarModal: PropTypes.func,
    showSendReviewModal: PropTypes.func,
    topicId: PropTypes.number,
    viewPlan: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.throttleGetStudyPlan = throttle(this.props.getStudyPlan, 300);
    this.state = {
      showFinishButtons: false,
      errorMention: true,
      usersModalVisible: false,
      mention: props.mention,
      isFavourite: props.isFavourite,
      planStatus: _get(props, 'plan.topic.planStatus.planStatus'),
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.actionType === 'setReviewPlan') {
      this.props.checkTopicComment(this.props.topicId, response => {
        if (response) {
          this.setState({ errorMention: true });
        } else {
          this.setState({ errorMention: false });
        }
      });
    }
    if (this.props.mention) {
      this.setState({ mention: this.props.mention });
    }
  }

  handleFavoriteClick = () => {
    this.props.createProfileUserTopic(this.props.currentUserId, this.props.topicId, 'anotherPlan', () => {
      this.setState({ isFavourite: true });
    });
  };

  handleDeleteClick = () => {
    this.props.deleteProfileUserTopic(this.props.topicId, true, true, 'anotherPlan', () => {
      this.setState({ isFavourite: false });
    });
  };

  getStudyPlan = () => {
    if (this.props.viewPlan) {
      this.props.clearPlan();
    } else {
      this.throttleGetStudyPlan(
        false,
        this.props.currentUserId,
        dayjs(this.props.activeMonth, 'YYYY-MM-DD'),
        this.props.page
      );
    }
  };

  render() {
    const { plan, isAnother, externalLogin, favouriteClass, t } = this.props;
    const { isFavourite } = this.state;

    const isExternalLogin = plan.topic.scope !== 'EXTERNAL' && externalLogin;

    const toMyCollectionButton = isFavourite ? (
      <Button
        className={classNames(
          css['App-btn'],
          css['App-btn-ghost'],
          css['App-favorite'],
          isExternalLogin && favouriteClass
        )}
        type='link'
        onClick={this.handleDeleteClick}
        size='large'
        icon={<HeartFilled className={css['App-btn-icon']} />}
      ></Button>
    ) : (
      <Button
        className={classNames(css['App-btn'], css['App-btn-ghost'], isExternalLogin && favouriteClass)}
        onClick={this.handleFavoriteClick}
        type='link'
        size='large'
        icon={<HeartOutlined className={css['App-btn-icon']} />}
      ></Button>
    );

    if (isAnother) {
      return !externalLogin || plan.topic.scope === 'EXTERNAL' ? (
        <MaterialButton topic={plan.topic} className={css['App-btn']} />
      ) : (
        toMyCollectionButton
      );
    }
    return null;
  }
}

const mapStateToProps = createSelector(
  [usersSelect, studyPlanSelect, loginSelect, selectOpenDate],
  (users, studyPlan, login, openDate) => ({
    openDate,
    currentUserId: users.currentUser && users.currentUser.id,
    viewPlan: studyPlan.view,
    usersList: users.usersList && users.usersList,
    usersPageSize: users.usersPageSize,
    usersPageNumber: users.usersPageNumber,
    usersTotal: users.usersTotal,
    externalLogin: login.externalLogin,
    updateButton: studyPlan.updateButton,
  })
);

const mapActionsToProps = {
  eventRequestConfirmUI,
  eventRequestRefuseUI,
  updateStudyPlanStatus,
  deleteStudyPlan,
  checkStudyPlan,
  clearPlan,
  checkTopicComment,
  getStudyPlan,
  getStudyPlanDinamic,
  createProfileUserTopic,
  finishAllPlansForTopics,
  getIncome,
  getUserById,
  deleteProfileUserTopic,
  eventRequestFinish,
  sendNotification,
  sendNotificationStudyPlanFinished,
  showSendReviewModal,
  createUserTopicToMultipleUsers,
  getUsers,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('studyPlanButton')(StudyPlanButton));
